<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/build' }">党建专栏</el-breadcrumb-item>
        <el-breadcrumb-item>党建详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>二十大精神关键词解读｜“两个确立”：理论、历史和实践逻辑的有机统一</h2>
        <p style="text-align: right"><span style="margin-right: 60px">2022-11-13</span></p>
        <p>
          党的二十大报告指出，十八大以来，我们党勇于进行理论探索和创新，以全新的视野深化对共产党执政规律、社会主义建设规律、人类社会发展规律的认识，取得重大理论创新成果，集中体现为新时代中国特色社会主义思想。确立习近平同志党中央的核心、全党的核心地位，确立习近平新时代中国特色社会主义思想的指导地位，体现了马克思主义理论逻辑、党的百年奋斗历史逻辑同新时代党和国家事业发展实践逻辑的有机统一，是我们党在新时代取得的重大政治成果、作出的重要历史贡献。我们必须从马克思主义政党的根本原则、党百年奋斗的历史经验，特别是从新时代取得的历史性成就、发生的历史性变革中，深刻领会和把握“两个确立”的决定性意义，增强坚定拥护“两个确立”、坚决做到“两个维护”的思想自觉、政治自觉、行动自觉。
        </p>
        <p>
          <b>一、“两个确立”体现了马克思主义政党根本原则</b>
        </p>
        <p>
          马克思认为，无产阶级在反对有产阶级联合力量的斗争中，只有把自身组织成为与有产阶级建立的一切旧政党不同的、相对立的政党，才能作为一个阶级来行动。这个先进政党，在实践方面，“是各国工人政党中最坚决的、始终起推动作用的部分”，在理论方面，“他们胜过其余无产阶级群众的地方在于他们了解无产阶级运动的条件、进程和一般结果”。这是马克思主义政党能够领导人民实现自己历史使命的根本保证。
        </p>
        <p>
          一方面，只有坚持党的集中统一和维护党的领袖的权威，党才能成为“最坚决的、始终起推动作用的部分”。马克思在《资本论》中根据现代社会生产组织规律的考察，指出：“一切规模较大的直接社会劳动或共同劳动，都或多或少地需要指挥，以协调个人的活动，并执行生产总体的运动……一个单独的提琴手是自己指挥自己，一个乐队就需要一个乐队指挥。”恩格斯强调：“为了进行斗争，我们必须把我们的一切力量捏在一起，并使这些力量集中在同一个攻击点上。如果有人对我说，权威和集中是两种在任何情况下都应当加以诅咒的东西，那么我就认为，说这种话的人，要么不知道什么叫革命，要么只不过是口头革命派。”列宁在领导创建俄国马克思主义政党的过程中，进一步论证集中和权威对于革命政党的重要性。他强调：“在历史上，任何一个阶级，如果不推举出自己的善于组织运动和领导运动的政治领袖和先进代表，就不可能取得统治地位。”“做不到这一点，无产阶级专政、无产阶级的‘意志统一’就只能是一句空话。”
        </p>
        <p>
          另一方面，只有坚持马克思主义科学理论的指导，党才能始终“了解无产阶级运动的条件、进程和一般结果”。以马克思主义的科学世界观作为党的理论基础，是无产阶级政党先进性的决定条件。恩格斯指出：“我们党有个很大的优点，就是有一个新的科学的世界观作为理论的基础。”列宁也深刻阐述了科学理论对于无产阶级先进政党和它所领导的革命运动的重要意义，指出：“没有革命的理论，就不会有革命的运动。”“只有以先进理论为指南的党，才能实现先进战士的作用。”列宁还阐述了科学社会主义学说不是自发产生的，而只能是从像马克思、恩格斯这样学识丰富的知识分子创造的哲学、历史和经济的理论中产生出来的。既然自发的工人运动不能产生科学社会主义，那么就需要从外面把这种科学思想意识灌输进去，必须坚持用马克思主义科学理论武装党员、教育群众，提高他们的阶级意识、思想觉悟，在这个过程中必须始终同形形色色的非马克思主义思想进行坚决彻底的斗争，从而为党的团结统一奠定强大思想基础。同时，马克思主义经典作家一再告诫人们，马克思主义理论是科学，不能把它当作一成不变的教义和必须背得滚瓜烂熟并机械地加以重复的教条，而应该将其作为行动的指南、作为进一步研究的出发点和可供使用的方法，并在实践中不断丰富和发展。可以说，一部马克思主义发展史就是马克思、恩格斯以及他们的后继者们不断根据时代、实践、认识发展而发展的历史。
        </p>
        <p>
          确立和维护党的领袖的权威和科学理论的指导地位，不仅是马克思主义的根本理论原则，而且是国际共产主义运动的重要经验。正是因为有了马克思、恩格斯这样的领袖，有了他们创立的科学理论即马克思主义的指导，才有了国际共产主义运动蓬勃兴起和各国工人运动发展；正是因为有了列宁这样的权威，创立了马克思主义基本原理与俄国革命的具体实际相结合的列宁主义，才有了俄国布尔什维克党领导俄国人民取得十月革命的胜利，开创了人民历史新纪元。我们党鲜明提出“两个确立”，就是马克思主义科学理论原则和国际共产主义运动重大历史经验在当代中国的创造性运用，体现了中国共产党人对科学真理和崇高事业的坚守和追求。
        </p>
        <p>
          <b>二、“两个确立”凝结了党百年奋斗的历史经验</b>
        </p>
        <p>
          中国共产党是按照马克思主义建党原则建立起来的，党的一大纲领把党定名为“中国共产党”，将科学社会主义的核心内容写进第一个党纲。党的一大选举产生中央局作为党的中央领导机关，领导全党的活动和工作。党的二大开始运用马克思主义的基本原理解决中国革命的实际问题，提出反帝反封建的民主革命纲领和最终实现共产主义的最高纲领。二大通过的第一部党章明确规定：“全国代表大会为本党最高机关，在全国大会闭会期间，中央执行委员会为最高机关。”“全国大会及中央执行委员会之议决，本党党员皆须绝对服从之。”这表明中国共产党一诞生就把马克思主义作为自己的行动指南，就确立了党中央集中统一领导的重要原则。但是在党的早期，由于我们党还不成熟，加之共产国际的影响，一直到1935年遵义会议前，都没有能够确立党中央和全党的领导核心，因而也没有形成一个成熟、稳定和有能力的党中央；同时，尽管我们党从一开始就接受马克思列宁主义作为党的指导思想，但也存在着把马克思主义教条化、神圣化的倾向，这就决定了当时条件下难以形成马克思主义同中国革命的具体实际相结合的系统化的思想理论。这两个方面构成了党领导的革命事业在早期屡遭挫折甚至面临失败危险的最重要原因。
        </p>
        <p>
          遵义会议确立了毛泽东同志在党中央和红军中的领导地位，开启了我们党独立自主解决中国革命实际问题的新阶段。但是，遵义会议后，全党真正深刻认识到维护党中央权威和集中统一领导的重大意义并成为自觉行动还经历了一个过程。在这个过程中，我们党进一步认识到党中央集中统一领导和党的领导核心的极端重要性。尤其是红军长征到达陕北后，毛泽东同志充分利用相对稳定的局势和环境，全面总结中国革命正反两方面的经验，系统思考中国革命的一系列重大问题，创造性地写出了一系列马克思主义中国化的重要著作，如《中国革命战争的战略问题》《实践论》《矛盾论》《论持久战》《中国革命和中国共产党》《新民主主义论》等，创立了马克思列宁主义的理论与中国革命实际之统一的思想——毛泽东思想。经过延安整风，党的七大郑重地把毛泽东思想写入党章，确立为我们党的指导思想，毛泽东同志在党中央和全党的领导核心地位完全确立和巩固下来。正是因为有毛泽东同志的正确领导，有毛泽东思想的科学指引，我们党才形成了思想上、政治上、组织上的空前的团结统一，才领导人民取得了新民主主义革命和社会主义建设的伟大胜利。
        </p>
        <p>
          改革开放后，邓小平提出为了坚持党的领导，必须努力改善党的领导，其中最重要的是全党服从中央的集中统一领导。20世纪80年代末90年代初，面对国内外形势深刻复杂变化，邓小平多次强调确立领导核心的重大意义：“任何一个领导集体都要有一个核心，没有核心的领导是靠不住的。”“最关紧要的是有一个团结的领导核心。这样保持五十年，六十年，社会主义中国将是不可战胜的。”改革开放之初及之后的相当长一个时期，由于有了邓小平同志作为党的领导核心，有了邓小平理论作为党的指导思想，我们党才成功开创了中国特色社会主义，保证了改革开放和社会主义现代化建设顺利推进。以江泽民同志为主要代表的中国共产党人，形成并贯彻“三个代表”重要思想，在国内外形势十分复杂的严峻考验面前，成功把中国特色社会主义推向二十一世纪。以胡锦涛同志为主要代表的中国共产党人，提出并坚持科学发展观，抓住重要战略机遇期，成功在新形势下坚持和发展了中国特色社会主义。
        </p>
        <p>
          历史经验证明，确立并维护党的领袖权威，确立并坚持马克思主义科学理论的指导地位，是我们党领导人民不断取得革命、建设和改革伟大成就的根本政治保证。“两个确立”凝结了党百年奋斗的历史经验，是我们党从百年奋斗历程中得出的必然结论。
        </p>
        <p>
          <b>三、“两个确立”是新时代伟大实践的必然结论</b>
        </p>
        <p>
          党的十八大以来，面对世所罕见、史所罕见的国内外复杂严峻环境和艰巨繁重的改革发展稳定任务，以习近平同志为核心的党中央以伟大的历史主动精神、巨大的政治勇气、强烈的责任担当，统筹把握中华民族伟大复兴战略全局和世界百年未有之大变局，团结带领全党全国人民攻克了许多长期没有解决的难题，办成了许多事关长远的大事要事，推动党和国家事业取得历史性成就、发生历史性变革。
        </p>
        <p>
          新时代十年的一系列原创性思想、关键性抉择、战略性举措，一系列变革性实践、突破性进展、标志性成果，都是习近平总书记亲自谋划、亲自部署、亲自指挥的结果，充分彰显出习近平总书记作为马克思主义政治家、思想家、战略家的政治胆魄、高超的政治智慧、卓越的领导才能、坚强的意志品质，展现出习近平总书记作为核心的定海神针作用。比如，面对贫中之贫、困中之困这块难啃的“硬骨头”，习近平总书记果断发出脱贫攻坚战总攻令，既挂帅又出征，推动五级书记抓脱贫，全党动员促攻坚，打赢了人类历史上最大规模脱贫攻坚战，创造了中华民族历史的奇迹。比如，面对突如其来的新冠肺炎疫情，习近平总书记统揽全局，果断决策，坚持人民至上、生命至上，领导全国人民同心协力、众志成城，统筹疫情防控和经济社会发展取得重大积极成果。比如，面对国际局势急剧变化等严峻复杂的外部环境，习近平总书记果断提出总体国家安全观，带领我们进行坚决斗争，在斗争中维护国家尊严和核心利益，牢牢掌握了我国发展和安全主动权。党的十八大以来，正是因为有习近平总书记的掌舵领航，我们党才带领人民打赢了一场又一场硬仗，取得了一个又一个重大胜利。
        </p>
        <p>
          习近平总书记的核心地位既是在新时代伟大斗争中形成的，也是在不断开辟马克思主义中国化时代化新境界中确立的。在新时代中国特色社会主义波澜壮阔的伟大实践中，习近平总书记以马克思主义政治家、思想家、战略家的深刻洞察力、敏锐判断力、理论创造力，坚持把马克思主义基本原理同中国具体实际相结合、同中华优秀传统文化相结合，坚持运用辩证唯物主义和历史唯物主义，对事关新时代党和国家事业发展的一系列重大理论和实践问题进行了深邃思考，科学回答中国之问、世界之问、人民之问、时代之问，提出一系列原创性治国理政的新理念新思想新战略，是习近平新时代中国特色社会主义思想的主要创立者。这一重要思想深刻回答了新时代坚持和发展什么样的中国特色社会主义、怎样坚持和发展中国特色社会主义，建设什么样的社会主义现代化强国、怎样建设社会主义现代化强国，建设什么样的长期执政的马克思主义政党、怎样建设长期执政的马克思主义政党等重大时代课题，以全新的视野深化了对共产党执政的规律、社会主义建设规律、人类社会发展规律的认识，实现了马克思主义中国化时代化新的飞跃。这一重要思想，坚持和运用马克思主义基本原理，不仅对马克思主义哲学、政治经济学、科学社会主义作出了许多重大创新，而且对经济、政治、法治、科技、文化、教育、民生、民族、宗教、社会、生态文明、国家安全、国防和军队、“一国两制”和祖国统一、统一战线、外交、党的建设等各方面作出新的理论概括和战略指引，构建起系统科学的全新理论体系。在当代中国，坚持和发展习近平新时代中国特色社会主义思想，就是真正坚持和发展马克思主义。党的十八大以来，正是因为有习近平新时代中国特色社会主义思想的科学指引，中国特色社会主义巍巍巨轮才能破浪前行，不断驶向中华民族伟大复兴的光辉彼岸。
        </p>
        <p>
          新时代的伟大实践充分证明，确立习近平同志党中央的核心、全党的核心地位，确立习近平新时代中国特色社会主义思想的指导地位，体现了全党共同意志和全国各族人民共同心愿，是时代、历史和人民的必然选择，是我们应对前进道路上一切不确定性的最大确定性，是全面建设社会主义现代化国家、全面推进中华民族伟大复兴最为可靠的保证。应对前进道路上的各种风险挑战、解决前进道路上的各种矛盾和问题，胜利实现我们的奋斗目标，离不开成熟稳健、有崇高威望的领导核心掌舵领航，离不开新时代党的创新理论的科学指引。只要全党深刻领悟“两个确立”的决定性意义，增强“四个意识”、坚定“四个自信”、做到“两个维护”，心往一处想、劲往一处使，团结凝聚成“一块坚硬的钢铁”，就一定能够带领人民战胜前进道路上的一切风险挑战，谱写全面建设社会主义现代化国家崭新篇章，以中国式现代化全面推进中华民族伟大复兴。
        </p>
        <p style="text-indent: 0; font-weight: 700">
          声明:转载此文是出于传递更多信息、利于普法之目的。若有来源标注错误或侵犯了您的合法权益，请作者持权属证明与广东东进联系，我们将及时更正、删除，谢谢。
        </p>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({ name: 'Build7' })">&lt;
            上一条&nbsp;&nbsp;&nbsp;&nbsp;深刻把握“第二个结合”的精髓要义...</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" style="text-align: right" class="hidden-xs-only">
          <span style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'Build5' })">以中国式现代化全面推进中华...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" class="hidden-sm-and-up">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({ name: 'Build5' })">下一条 &gt;
            &nbsp;&nbsp;&nbsp;&nbsp;以中国式现代化全面推进中华...</span>
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        img: [require('@/assets/news5.png')]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .kongxi {
    height: 10px;
  }

  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }

  @media screen and (max-width: 768px) {
    .content {
      width: 90%;
      margin: 0 auto;

      h2 {
        font-family: 黑体, SimHei;
        font-size: 24px;
        margin: 20px 0;
        text-align: center;
      }

      p {
        font-size: 16px;
        margin: 20px 0;
        text-align: justify;
        text-indent: 2em;
        color: #515050;
        font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
      }
    }
  }
</style>